export default "__VITE_ASSET__CJWXHfI0__"